export const BRAND = {
  short: "BB Power",
  full: "Bada Biplab Power Solutions",
  tagline: "A Complete Power Solution for IT & Industrial Applications.",
  subTagline: "Everything About Power Solutions",
  logo: "https://customer-assets.emergentagent.com/job_power-solutions-131/artifacts/1pb48xts_BadaBiplab_Logo-1.png",
  phone: "+91 9862770077",
  phoneHref: "+919862770077",
  email: "sales@bbpowersolutions.in",
  address: {
    line1: "Badharghat Chowmuhani, Agartala",
    line2: "Tripura West",
    landmark: "Besides TGB Bank",
    pin: "799003",
  },
  hours: "Mon – Sat · 9:00 AM – 6:00 PM",
  emergency: "Emergency Support 24/7",
};

export const NE_STATES = [
  { code: "AS", name: "Assam" },
  { code: "TR", name: "Tripura" },
  { code: "ML", name: "Meghalaya" },
  { code: "AR", name: "Arunachal Pradesh" },
  { code: "MZ", name: "Mizoram" },
  { code: "NL", name: "Nagaland" },
  { code: "SK", name: "Sikkim" },
  { code: "MN", name: "Manipur" },
];

export const ADVANTAGES = [
  { no: "01", title: "Regional Infrastructure", body: "Local offices and warehouses across West Bengal, Bihar, Odisha, Jharkhand and all Northeast states — significantly reducing delivery times." },
  { no: "02", title: "Government Ready", body: "Registered vendor for Govt & PSUs with a focus on winning and executing large-scale public sector tenders." },
  { no: "03", title: "Logistics Excellence", body: "Insured transportation with Hydra and crane handling for heavy equipment across the toughest terrains." },
  { no: "04", title: "Vendor Neutrality", body: "Largest variety of trusted brands. We engineer the right solution — not push a single product." },
  { no: "05", title: "Expert Team", body: "Highly qualified engineering support for the entire spectrum — concept, design, supply, install, commission." },
];

export const CORE_CATEGORIES = [
  {
    code: "C-01",
    title: "Comprehensive UPS Systems",
    items: ["Online UPS", "Off-Line UPS", "Industrial UPS", "Rack-Mount UPS", "Tower UPS"],
  },
  {
    code: "C-02",
    title: "Advanced Battery Solutions",
    items: ["SMF Battery", "VRLA Battery", "NICD Battery", "Lithium Battery"],
  },
  {
    code: "C-03",
    title: "Renewable Energy",
    items: ["Solar Inverter — On-Grid", "Solar Inverter — Off-Grid", "Hybrid Plant Design"],
  },
  {
    code: "C-04",
    title: "Precision Data Centre Cooling",
    items: ["Cooling Rack", "Modular Rack Cooling", "VRC Self-Contained IT Rack Cooling"],
  },
];

export const PRODUCTS = [
  {
    code: "P-01",
    title: "UPS & Power Protection",
    blurb: "Premium UPS, inverter, stabilizer and isolation transformer systems engineered for critical IT and industrial loads.",
    items: [
      "Online UPS — Sales & Rentals",
      "Heavy-duty Inverters",
      "Servo Stabilizers (SCVS / SSVS)",
      "Isolation Transformers (medical, lab, IT)",
    ],
  },
  {
    code: "P-02",
    title: "Batteries & Storage",
    blurb: "Comprehensive industrial battery range — sealed, lead-acid, nickel and lithium chemistries for every application.",
    items: ["SMF (Sealed Lead Acid)", "VRLA (2V & 12V)", "NICD Battery Banks", "Lithium Battery Systems"],
  },
  {
    code: "P-03",
    title: "Renewable Energy Solutions",
    blurb: "End-to-end on-grid and off-grid solar plant design, supply and commissioning — commercial, industrial and residential.",
    items: ["On-Grid Solar Plants", "Off-Grid Solar Plants", "Hybrid Solar Systems"],
  },
  {
    code: "P-04",
    title: "Electrical Panels & Fabrication",
    blurb: "Standard and custom panels plus site-specific fabrication for racks and UPS mounting basements.",
    items: ["ACDB / DCDB Panels", "Battery Chargers", "Change-Over Panels", "Junction Boxes", "Custom Battery Racks", "UPS Mounting Basements"],
  },
  {
    code: "P-05",
    title: "Backup Power Rentals",
    blurb: "High-capacity diesel and natural gas generator rentals for emergency and high-demand industrial needs.",
    items: ["Diesel Generator Rentals", "Natural Gas Generator Rentals", "On-Demand Standby Power"],
  },
  {
    code: "P-06",
    title: "Data Centre Cooling",
    blurb: "Precision in-row and self-contained rack cooling for data centres and IT closets — efficient, redundant, scalable.",
    items: ["In-Row Cooling Rack", "Modular Rack Cooling", "VRC Self-Contained Rack Cooling"],
  },
];

export const SERVICES = [
  {
    code: "S-01",
    title: "Turnkey Project Management",
    body: "We manage the entire project lifecycle under our SEIC protocol: Supply, Erection, Installation and Commissioning. Specialised teams handle all heavy lifting and precision shifting.",
    bullets: ["Site survey & engineering design", "Heavy-equipment handling (Hydra/Cranes)", "Loading, unloading and shifting", "Full SEIC delivery"],
  },
  {
    code: "S-02",
    title: "Installation & Commissioning",
    body: "Expert setup of complex electrical systems, UPS networks and solar plants — fully compliant with industrial grid and safety mandates.",
    bullets: ["Compliance-led installation", "UPS network integration", "Solar plant commissioning", "Acceptance testing & handover"],
  },
  {
    code: "S-03",
    title: "Maintenance Contracts (AMC)",
    body: "Comprehensive (CAMC) and Non-Comprehensive (NAMC) annual maintenance contracts. Routine checkups plus targeted preventive maintenance.",
    bullets: ["CAMC — all-inclusive", "NAMC — preventive only", "SLA-backed response", "Documented site reports"],
  },
  {
    code: "S-04",
    title: "Preventive Maintenance & Servicing",
    body: "Regular diagnostic visits to prevent unexpected failures. Specialised replacement and systematic testing across UPS, switchgear and telecom systems.",
    bullets: ["UPS AC/DC capacitor replacement", "Cooling fan service", "Battery diagnostics & cell balancing", "Switchgear inspection"],
  },
  {
    code: "S-05",
    title: "Retrofitting & Upgrades",
    body: "Modernise aging infrastructure. We retrofit older electrical panels, upgrade legacy UPS units and integrate IoT monitoring tools — without interrupting daily workflows.",
    bullets: ["Panel retrofitting", "Legacy UPS upgrades", "IoT monitoring integration", "Zero-downtime cutover"],
  },
  {
    code: "S-06",
    title: "Energy & Power Quality Management",
    body: "Smart monitoring, power factor correction and high-efficiency industrial lighting layouts — cut operational utility bills without compromising performance.",
    bullets: ["Smart energy monitoring", "Integrated billing systems", "Power factor correction", "Industrial LED retrofits"],
  },
];

export const DEPARTMENTS = [
  { id: "sales", label: "Sales & Inquiries", email: "sales@bbpowersolutions.in" },
  { id: "service", label: "Support & Service", email: "Service@bbpowersolutions.in" },
];

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/products", label: "Products" },
  { to: "/services", label: "Services" },
  { to: "/contact", label: "Contact" },
];
